import { getClient } from '@/lib/restClient';
import { StoreManagementMasterStoreService } from '@/services/StoreManagement/MasterStores/StoreManagementMasterStoreService';

export type StoreManagementMasterStoreUpdateParams = {
  name: string;
  auth_store_id: number;
  business_number: string | null;
  business_name: string | null;
};

export const useStoreManagementMasterStoreUpdate = async (
  id: number,
  params: StoreManagementMasterStoreUpdateParams
): Promise<void> => {
  const storeManagementMasterStoreService =
    new StoreManagementMasterStoreService(getClient());
  return await storeManagementMasterStoreService.update(id, params);
};
